import { render, staticRenderFns } from "./PassedTestings.vue?vue&type=template&id=11a5af56"
import script from "./PassedTestings.vue?vue&type=script&lang=ts"
export * from "./PassedTestings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports